import {
  callApiLayDanhSachNguoiDung,
  callApiLayHoTenCanBo,
} from "@/api/permission";

const layDanhSachQuyenNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachNguoiDung(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_QUYEN_NGUOI_DUNG", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layHoTenCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayHoTenCanBo(payload)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachPhanQuyenNguoiDung = (context, payload) => {
  context.commit("SET_DANH_SACH_PHAN_QUYEN_NGUOI_DUNG", payload);
};

const layDanhSachChiTietNguoiDung = (context, payload) => {
  context.commit("SET_DANH_SACH_CHI_TIET_NGUOI_DUNG", payload);
};
export default {
  layDanhSachQuyenNguoiDung,
  layHoTenCanBo,
  layDanhSachChiTietNguoiDung,
  layDanhSachPhanQuyenNguoiDung,
};
